module.exports = __webpack_public_path__ + "media/images/features/private_and_secure_img-1b938216160e15fcddc14886eb976517.png";